// extracted by mini-css-extract-plugin
export default {"cls1":"buttonStyles-cls1_wuC","cls2":"buttonStyles-cls2_BTj buttonStyles-cls1_wuC"};